import { ENDPOINTS } from '@polyai/stream/endpoints';
import type { RootState } from '@polyai/stream/store';

import { doGet } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';

export type GetProjectionResponse = {
  lastKnownSequence: string;
  projection: RootState;
};

export const getProjection = ({
  accountId,
  projectId,
  branchId,
}: {
  accountId: string;
  projectId: string;
  branchId: string;
}) => {
  return doGet<GetProjectionResponse>(
    generateNextPath(ENDPOINTS.BRANCH_PROJECTION, {
      accountId,
      projectId,
      branchId,
    }),
    LOGGER_TYPE.JUPITER,
    {
      prefix: 'sourcerer',
    },
  );
};

export const getLatestSequence = ({
  accountId,
  projectId,
  branchId,
}: {
  accountId: string;
  projectId: string;
  branchId: string;
}) => {
  return doGet<Omit<GetProjectionResponse, 'projection'>>(
    generateNextPath(ENDPOINTS.BRANCH_SEQUENCE, {
      accountId,
      projectId,
      branchId,
    }),
    LOGGER_TYPE.JUPITER,
    {
      prefix: 'sourcerer',
    },
  );
};
